import { BookingStatusEnum, QuoteState } from "../../../requests-module"
import bookingQuoteResponse from "@/state/bookingQuoteResponse"
import locale from "@/state/locale"
import { Booking } from "./classes"
import getBookingObject from "./logic/getBookingObject"

class TrackingObject {
    'event': 'booking.cart' | 'Booking'
    'PageName': string
    'Dossier_Montant-TTC': string // total price
    'Dossier_Montant-TTC-Arrondi': number // total price rounded
    'Dossier_Montant-HT': string
    'Dossier_Montant-HT-Arrondi': number // price / 1.2 rounded
    'Prest_Id': string
    'Lihe_Id': string
    'Date_debut': string
    'Duree': number
    'Ville_Id': string
    'Ville_Nom': string
    'Typp_Id'?: number
    'Dossier_Reference-Dossier'?: string
    'DOSSIER_ETAT'?: string
    "booking"?: Booking
    "paymentType"?: string
    "isNewUser"?: boolean
    "locale"?: string

    constructor(
        event: 'booking.cart' | 'Booking',
        pageName: string,
        dossier_Montant_TTC: string,
        dossier_Montant_TTC_Arrondi: number,
        dossier_Montant_HT: string,
        dossier_Montant_HT_Arrondi: number,
        prest_Id: string,
        lihe_Id: string,
        date_debut: string,
        duree: number,
        ville_Id: string,
        ville_Nom: string,
    ) {
        this['event'] = event
        this['PageName'] = pageName
        this['Dossier_Montant-TTC'] = dossier_Montant_TTC
        this['Dossier_Montant-TTC-Arrondi'] = dossier_Montant_TTC_Arrondi
        this['Dossier_Montant-HT'] = dossier_Montant_HT
        this['Dossier_Montant-HT-Arrondi'] = dossier_Montant_HT_Arrondi
        this['Prest_Id'] = prest_Id
        this['Lihe_Id'] = lihe_Id
        this['Date_debut'] = date_debut
        this['Duree'] = duree
        this['Ville_Id'] = ville_Id
        this['Ville_Nom'] = ville_Nom
    }
}


const getEvent = (isHaveBooking: boolean): 'booking.cart' | 'Booking' => {
    if (isHaveBooking) return 'booking.cart'
    return 'Booking'
}


const getTypp_Id = (packCode: string | undefined) => {
    if (!packCode) return undefined
    if (packCode === 'HS') return 10
    return 2
}


const getStatus = (isHaveBooking: boolean, status: BookingStatusEnum | null | undefined): string | undefined => {
    if (!isHaveBooking || !status) return undefined
    const mapping = new Map([
        [BookingStatusEnum.PANIER_EN_COURS, ''],
        [BookingStatusEnum.QUOTE, "quote"],
        [BookingStatusEnum.RESERVATION, "reservation"],
    ])
    return mapping.get(status)
}

const getDuration = (startDateTimestamp: number, endDateTimestamp: number) => {
    return Math.floor((endDateTimestamp - startDateTimestamp) / (24 * 60 * 60 * 1000))
}


const tracking_booking = () => {
    try {
        if (!bookingQuoteResponse.value) throw new Error("cannot send tracking data without bookingQuoteResponse.value")
        const state: QuoteState = bookingQuoteResponse.value.state
        const booking: QuoteState | undefined | null = bookingQuoteResponse.value.booking
        const isHaveBooking = !!booking

        const totalPrice: number = state.totalPrice
        const startDate: string = state.startDate
        const endDate: string = state.endDate

        // calculate duration
        const d1: string[] = startDate.split('-');
        const startDateTimestamp = new Date(Number(d1[0]), Number(d1[1]), Number(d1[2])).getTime();
        const d2: string[] = endDate.split('-');
        const endDateTimestamp = new Date(Number(d2[0]), Number(d2[1]), Number(d2[2])).getTime();
        const duration: number = getDuration(startDateTimestamp, endDateTimestamp);

        const event: 'booking.cart' | 'Booking' = getEvent(isHaveBooking) // TODO make this dynamic
        const PageName: string = window.location.pathname
        const dossier_Montant_TTC = (totalPrice / 100).toString().split('.').join(',')
        const dossier_Montant_TTC_Arrondi = Math.ceil(totalPrice / 100)
        const dossier_Montant_HT = (Math.ceil(totalPrice / 1.2) / 100).toString().split('.').join(',')
        const dossier_Montant_HT_Arrondi = Math.ceil(totalPrice / 1.2 / 100)
        const Prest_Id = "" // = this.bookingData.prestId
        const Lihe_Id: string = state.liheId
        const date_debut: string = startDate.split('-').reverse().map((n) => parseInt(n)).join('-')
        const duree = duration
        const ville_Id = "" // this.info.stationId
        const ville_Nom = "" // = this.info.stationName
        const Typp_Id: number | undefined = NaN // = getTypp_Id(this.info.packCode)
        const ext_ref: string | undefined = isHaveBooking ? bookingQuoteResponse.value?.booking?.bookingRef : undefined
        const status: string | undefined = getStatus(isHaveBooking, bookingQuoteResponse.value?.booking?.status)

        const data: TrackingObject = new TrackingObject(
            event,
            PageName,
            dossier_Montant_TTC, // total price
            dossier_Montant_TTC_Arrondi, // total price rounded
            dossier_Montant_HT, // price / 1.2
            dossier_Montant_HT_Arrondi, // price / 1.2 rounded
            Prest_Id,
            Lihe_Id,
            date_debut,
            duree,
            ville_Id,
            ville_Nom,
        )

        if (Typp_Id) data.Typp_Id = Typp_Id
        if (ext_ref) data['Dossier_Reference-Dossier'] = ext_ref;
        if (status) data['DOSSIER_ETAT'] = status;

        data['locale'] = locale.value || undefined;

        if (isHaveBooking) {
            data['booking'] = getBookingObject();
        }

        window.dataLayer.push(data);
    } catch (err) {
        console.error(err)
    }
}

export default tracking_booking
